import styled from 'styled-components';
import { theme } from '../../styles';
export const ButtonTrigger = styled.button `
  appearance: none;
  background-color: transparent;
  border: none;
  display: inline-block;
  cursor: pointer;
  padding: 0;
  text-decoration: none;
`;
export const Heading = styled.h2 `
  border-bottom: 1px solid #cccccc;
  font-family: ${theme.fontFamily.text};
  font-size: 1.5rem;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  text-align: center;
`;
export const Form = styled.form `
  background-color: #fff;
  display: block;
  width: 100%;
  padding: 1rem;
`;
export const Label = styled.label `
  display: grid;
  grid-template-columns: 2rem 1fr;
`;
export const CookieBlock = styled.div `
  margin-bottom: 1rem;
  font-size: 1rem;
`;
export const Description = styled.div `
  padding-left: 2rem;
`;
export const CookieHeading = styled.h3 `
  font-family: ${theme.fontFamily.text};
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 0;
`;
export const Checkbox = styled.input `
  appearance: none;
  border: 1px solid #333;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  &:checked {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' fill='%23333'/%3E%3C/svg%3E");
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
  &:disabled {
    border: 1px solid #aaa;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' fill='%23aaa'/%3E%3C/svg%3E");
    box-shadow: none;
    cursor: not-allowed;
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 0.2rem rgba(109, 142, 162, 0.5);
  }
`;
//# sourceMappingURL=styled.js.map